import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { REGULAR } from '~/lib/constants';

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

export function pluralise(count: number, singular: string, plural: string) {
    return count <= 1 ? singular : plural;
}

export const urlify = (value: string) => {
    return value.trim().replace(/\s/g, '%20');
};

export function redirectToThankYouPage({ service, booking_id, preserveQuery = true }: { service: string | null, booking_id?: string | null, preserveQuery?: boolean }) {
    const query = preserveQuery ? new URLSearchParams(window.location.search) : new URLSearchParams();
    query.set('booking_id', booking_id || '');
    query.set('step', '6');

    if (service === REGULAR) {
        window.location.href = `/thank-you-regular?${query.toString()}`;
    } else {
        window.location.href = `/thank-you-one-off?${query.toString()}`;
    }
}

export function handleThankYouRedirect(urlStep: number | null, currentPath: string, service: string | null) {
    if (urlStep === 6 && !currentPath.includes('thank-you')) {
        redirectToThankYouPage({ service });
        return true;
    }
    return false;
}
